export default "__VITE_ASSET__BRGLQ8GS__"